module.exports = __webpack_public_path__ + "img/Yostar@4x.02116041.png";